import { createContext } from "react";

import type { Size, Variant } from "./types";
import { DEFAULT_VARIANT, DEFAULT_SIZE } from "./utils";

type ButtonContextProps = {
    size: Size;
    variant: Variant;
};

export const ButtonContext = createContext<ButtonContextProps>({
    size: DEFAULT_SIZE,
    variant: DEFAULT_VARIANT,
});
